
import Vue from 'vue';
import { defineComponent } from 'vue';
import VueObserveVisibility from 'vue-observe-visibility';
import PrzLoader from '@/components/Muffin/Loader.vue';
import { SocialMention,SocialMediaSource, SocialMediaShape, SocialMediaSourceType } from '@/models/Social/social-mention';

Vue.use(VueObserveVisibility);

export default defineComponent({
    components: {
        PrzVideo: () => import('@/components/Muffin/Video/Component.vue'),
        PrzLoader
        //PrzVideo
    },
    props: {
        mention:{
            type: SocialMention,
            default: () => new SocialMention(undefined, undefined)
        },
        isDesktop:{
            type: Boolean,
            default: false
        }
    },
    data(){
        let timerShowLoader: any|undefined;
        return {
            indexSelected: 0,
            showLoader: false,
            timerShowLoader
        }
    },
    mounted(){
        if(this.hasVideo){
            let firstMedia: SocialMediaSource|null = this.sources.length > 0 ? this.sources[0] : null;
            let firstIsVideo = firstMedia ? firstMedia.type === SocialMediaSourceType.VIDEO : false;
            if(firstIsVideo){
                this.showLoader = true;
                this.timerShowLoader = setTimeout(() => {
                    this.showLoader = false;
                },10000);
            }
        }
    },
    computed:{
        sources(): Array<SocialMediaSource>{
            return this.mention?.post.media?.sources ?? [];
        },
        shape(): SocialMediaShape{
            return this.mention?.post.media?.shape ?? SocialMediaShape.SQUARE;
        },
        isSquare(): boolean{
            return this.shape == SocialMediaShape.SQUARE;
        },
        isVertical(): boolean{
            return this.shape == SocialMediaShape.VERTICAL;
        },
        videoWidth(): string{
            return '100svw';
        },
        showArrows(): boolean{
            return false;
        },
        imgClass(): string{
            if(this.isSquare){
                return 'prz-social-post-img';
            }
            let withRef = 390;
            let heightRef = 780;
            if((withRef / heightRef) > (window.innerWidth / window.innerHeight)){
                return 'prz-social-post-img-v';
            }
            return 'prz-social-post-img';
        },
        hasVideo(): boolean{
            let result = false;
            this.sources.forEach((s) => {
                if(s.type == SocialMediaSourceType.VIDEO){
                    result = true;
                }
            });
            return result;
        }
    },
    methods: {
        onplay(element: any){
            this.showLoader = false;
            clearTimeout(this.timerShowLoader);
            let elem = element instanceof HTMLElement ? element : null;
            if(elem){
                this.removePoster(elem);
                this.$emit("media-load", true);
            }
        },
        imgLoad(){
            this.$emit("media-load");
        },
        nextMedia(){
            this.selectMedia(this.indexSelected + 1);
        },
        previousMedia(){
            this.selectMedia(this.indexSelected - 1);
        },
        selectMedia(index: number){
            if(index > this.sources.length - 1){
                index = 0;
            }
            if(index < 0){
                index = 0;
            }
            let client: HTMLElement|null = this.$refs.media ? (this.$refs.media as HTMLElement) : null;
            let width: number = client ? client.offsetWidth : 0;
            let step: number  = index - this.indexSelected;
            let elem: HTMLElement|null = this.$refs.container ? (this.$refs.container as HTMLElement) : null;
            if(step && elem && width){
                let value: number = width * step;
                elem.scrollBy({
                    top: 0, 
                    left: value,
                    behavior: 'smooth'
                });
            }
        },
        removePoster(target: HTMLElement){
            if(target.classList.contains('prz-social-post-video')){
                target.style.backgroundImage = 'none';
            }
            if(target.tagName.toLocaleLowerCase() != 'body' && target.parentElement){
                this.removePoster(target.parentElement);
            }
        },
        isVideo(index: number): boolean{
            let source =  this.sources[index] ?? null;
            if(source){
                return source.type == 'video';
            }
            return false;
        },
        scroll(p: any){
            let elem: HTMLElement|null = p?.target ?? null;
            let container: HTMLElement|null = this.$el.querySelector('.prz-social-post-media');
            if(elem){
                let fullWidth = container?.offsetWidth ?? window.innerWidth;
                this.indexSelected = Math.round(elem.scrollLeft / fullWidth);
                this.$emit("mediaChange", {
                    isVideo: this.isVideo(this.indexSelected)
                });
            }
        }
    }
});
